'use strict';
/* Toddle + Tum — Shopify theme behaviour (bag drawer, shop filters, product page, forms). */
(function(){
const TT=window.TT||{};
const ROOT=TT.root||'/';
const MAX=TT.max||20;
const S=TT.strings||{};
const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];
const money=cents=>{
  try{return new Intl.NumberFormat(document.documentElement.lang||'en-AU',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'AUD'}).format(cents/100).replace(/^A\$/,'$');}
  catch{return '$'+(cents/100).toFixed(2);}
};
const url=p=>(ROOT.replace(/\/$/,'')+'/'+p.replace(/^\//,''));

/* ---------- Toast ---------- */
let toastTimer;
function toast(message){const t=$('#toast');if(!t)return;t.textContent=message;t.classList.add('show');clearTimeout(toastTimer);toastTimer=setTimeout(()=>t.classList.remove('show'),2800);}

/* ---------- Bag (Shopify cart) ---------- */
const bagDialog=$('#bagDialog');
function bagWrap(){return bagDialog&&bagDialog.querySelector('.shopify-section, .tt-bag-wrap')||bagDialog;}
function setCount(n){
  const c=$('#bagCount'); if(c)c.textContent=n;
  const b=$('#openBag'); if(b)b.setAttribute('aria-label',`Open shopping bag, ${n} item${n===1?'':'s'}`);
}
function renderBag(html){
  if(!html||!bagDialog)return;
  const doc=new DOMParser().parseFromString(html,'text/html');
  const src=doc.querySelector('.shopify-section')||doc.body;
  const wrap=bagWrap(); wrap.innerHTML=src.innerHTML;
  const items=$('#bagItems'); if(items)setCount(Number(items.dataset.count||0));
}
function lineQty(variantId){
  const row=bagDialog&&bagDialog.querySelector(`.bag-row[data-variant="${variantId}"]`);
  return row?Number(row.dataset.qty||0):0;
}
async function refreshBag(){
  try{const r=await fetch(url('?sections=bag'));const j=await r.json();renderBag(j.bag);}catch{}
}
async function addToBag(variantId,qty=1){
  variantId=String(variantId); qty=Number(qty)||1;
  if(lineQty(variantId)+qty>MAX){toast(S.max||`Maximum ${MAX} of each item, mate.`);return false;}
  try{
    const r=await fetch(TT.cartAdd+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:qty}],sections:'bag'})});
    const j=await r.json();
    if(!r.ok){toast(j.description||j.message||S.error);return false;}
    if(j.sections)renderBag(j.sections.bag);
    const it=(j.items&&j.items[0])||{};
    const v=it.variant_title&&!/default title/i.test(it.variant_title)?` (${it.variant_title.toLowerCase()})`:'';
    toast(`${it.product_title||''}${v} ${S.added||'added to your bag'}`.trim());
    return true;
  }catch{toast(S.error);return false;}
}
async function changeLine(line,quantity){
  try{
    const r=await fetch(TT.cartChange+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:Number(line),quantity:Math.max(0,Math.min(MAX,Number(quantity))),sections:'bag'})});
    const j=await r.json();
    if(!r.ok){toast(j.description||j.message||S.error);return;}
    if(TT.template==='cart'){location.reload();return;}
    if(j.sections)renderBag(j.sections.bag);
  }catch{toast(S.error);}
}
function openBag(){if(!bagDialog)return;if(!bagDialog.open)bagDialog.showModal();}

/* ---------- Header ---------- */
const menu=$('#menuButton'),nav=$('#navigation');
function setMenu(open){if(!nav||!menu)return;nav.classList.toggle('open',open);menu.setAttribute('aria-expanded',open);menu.setAttribute('aria-label',open?'Close menu':'Open menu');menu.textContent=open?'×':'☰';}
menu?.addEventListener('click',()=>setMenu(!nav.classList.contains('open')));
nav?.addEventListener('click',e=>{if(e.target.closest('a'))setMenu(false);});
$('#openBag')?.addEventListener('click',()=>{openBag();refreshBag();});

/* ---------- Global clicks ---------- */
document.addEventListener('click',async e=>{
  const b=e.target.closest('button,a'); if(!b)return;
  if(b.hasAttribute('data-close')){b.closest('dialog')?.close();return;}
  if(b.dataset.add){e.preventDefault();b.disabled=true;await addToBag(b.dataset.add,1);b.disabled=false;return;}
  if(b.dataset.line!==undefined&&b.dataset.qty!==undefined){e.preventDefault();b.disabled=true;await changeLine(b.dataset.line,b.dataset.qty);return;}
  if(b.dataset.topic){const sel=$('#cTopic');if(sel){e.preventDefault();const o=[...sel.options].find(o=>o.dataset.key===b.dataset.topic);if(o)sel.value=o.value;$('#cName')?.focus();}}
});
$$('dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}}));

/* ---------- Shop: filter + sort ---------- */
const grid=$('#shopGrid');
if(grid){
  const cards=[...grid.querySelectorAll('.product-card')]; let filter='all';
  const params=new URLSearchParams(location.search);
  const chips=$$('[data-filter]');
  if(params.get('type')&&chips.some(c=>c.dataset.filter===params.get('type')))filter=params.get('type');
  const sortEl=$('#sort');
  function apply(){
    const sort=sortEl?sortEl.value:'featured';
    const cmp={featured:(a,b)=>a.dataset.order-b.dataset.order,'price-asc':(a,b)=>a.dataset.price-b.dataset.price||a.dataset.order-b.dataset.order,'price-desc':(a,b)=>b.dataset.price-a.dataset.price||a.dataset.order-b.dataset.order,name:(a,b)=>a.dataset.name.localeCompare(b.dataset.name)}[sort];
    cards.sort(cmp).forEach(c=>{c.hidden=filter!=='all'&&c.dataset.type!==filter;grid.appendChild(c);});
    const n=cards.filter(c=>!c.hidden).length;
    const rc=$('#resultCount'); if(rc)rc.textContent=`${n} product${n===1?'':'s'}`;
    chips.forEach(c=>c.setAttribute('aria-pressed',c.dataset.filter===filter));
  }
  chips.forEach(c=>c.addEventListener('click',()=>{filter=c.dataset.filter;apply();const u=new URL(location.href);filter==='all'?u.searchParams.delete('type'):u.searchParams.set('type',filter);history.replaceState(null,'',u);}));
  sortEl?.addEventListener('change',apply);
  apply();
}

/* ---------- Product page ---------- */
const pdp=$('#pdp');
if(pdp){
  let qty=1;
  const main=$('#galleryMain'),mainImg=main&&main.querySelector('img');
  $$('.thumb').forEach(t=>t.addEventListener('click',()=>{
    $$('.thumb').forEach(x=>x.setAttribute('aria-current',x===t));
    if(!mainImg)return;
    mainImg.style.opacity=0;
    setTimeout(()=>{mainImg.removeAttribute('srcset');mainImg.src=t.dataset.src;mainImg.alt=t.dataset.alt;main.classList.toggle('photo',t.dataset.kind==='photo');mainImg.style.opacity=1;},150);
  }));
  const form=$('#pdpForm'), addBtn=$('#pdpAdd');
  const chosen=()=>form&&(form.querySelector('input[name="id"]:checked')||form.querySelector('input[name="id"][type="hidden"]'));
  function update(){
    const v=chosen(); if(!v)return;
    const price=Number(v.dataset.price||0);
    const pp=$('#pdpPrice'); if(pp)pp.textContent=money(price);
    const ap=$('#afterpayAmt'); if(ap)ap.textContent=money(Math.round(price/4));
    $('#qtyOut').textContent=qty; $('#qtyInput').value=qty; $('#qtyMinus').disabled=qty<=1; $('#qtyPlus').disabled=qty>=MAX;
    if(addBtn){
      const sold=v.disabled;
      addBtn.disabled=sold;
      addBtn.innerHTML=sold?`${addBtn.dataset.soldOut} <span aria-hidden="true">+</span>`:`${addBtn.dataset.label} · ${money(price*qty)} <span aria-hidden="true">+</span>`;
    }
    if(v.type==='radio'&&history.replaceState){const u=new URL(location.href);u.searchParams.set('variant',v.value);history.replaceState(null,'',u);}
  }
  form?.querySelectorAll('input[name="id"]').forEach(i=>i.addEventListener('change',update));
  $('#qtyMinus')?.addEventListener('click',()=>{qty=Math.max(1,qty-1);update();});
  $('#qtyPlus')?.addEventListener('click',()=>{qty=Math.min(MAX,qty+1);update();});
  form?.addEventListener('submit',async e=>{
    e.preventDefault(); const v=chosen(); if(!v)return;
    addBtn.disabled=true;
    const ok=await addToBag(v.value,qty);
    addBtn.disabled=false;
    if(ok){qty=1;update();openBag();}
  });
  update();
}

/* ---------- Contact form: preselect topic ---------- */
{
  const topic=new URLSearchParams(location.search).get('topic');
  const sel=$('#cTopic');
  if(topic&&sel){const o=[...sel.options].find(o=>o.dataset.key===topic);if(o)sel.value=o.value;}
}

/* ---------- Open FAQ from hash ---------- */
function openHash(){const el=location.hash&&document.getElementById(decodeURIComponent(location.hash.slice(1)));if(el&&el.tagName==='DETAILS')el.open=true;}
window.addEventListener('hashchange',openHash); openHash();

/* ---------- Theme editor: keep bag closed / reopen on select ---------- */
document.addEventListener('shopify:section:select',e=>{if(bagDialog&&e.target.closest&&e.target.closest('#bagDialog'))openBag();});
})();
